import Content from 'ui/Layout/Content/Content';
import styles from './CarPage.module.css';
import { getCopy } from './CarPage.copy';
import { useLanguage } from 'contexts/LanguageContext';
import CarPicsGrid from './CarPicsGrid/CarPicsGrid';
import cn from 'classnames';
import Link from 'ui/Links/Link/Link';
import { ReactComponent as ChevronLeftIcon } from 'assets/icons/ChevronLeft.svg';

const CarPage = () => {
    const [language] = useLanguage();
    const { title, bodyStages, videoTitle } = getCopy(language);
    const backToHomeCopy = language === 'es' ? 'Inicio' : 'Back to home';

    return (
        <>
            <div className={styles.homeLinkContainer}>
                <Content className={styles.content}>
                    <Link href="/" className={styles.homeLink}>
                        <ChevronLeftIcon />
                        <span>{backToHomeCopy}</span>
                    </Link>
                </Content>
            </div>

            <div className={styles.container}>
                <section className={styles.section} aria-label="car description and images">
                    <Content className={styles.content}>
                        <h2>{title}</h2>
                        <div className={styles.body}>
                            {bodyStages.map((stage, index) => (
                                <p key={index}>{stage}</p>
                            ))}
                        </div>

                        <CarPicsGrid />
                    </Content>

                    <div className={styles.blurEffect} aria-hidden>
                        <div className={styles.carDescriptionPurpleBlob} />
                        <div className={styles.carDescriptionBlueBlob} />
                    </div>
                </section>

                <section className={cn(styles.section, styles.videoSection)} aria-label="soltera video">
                    <Content className={styles.content}>
                        <h2>{videoTitle}</h2>
                        <div className={styles.solteraVideo}>
                            <iframe
                                src="https://www.youtube.com/embed/oBofuVYDoG4?si=6AN9hXE-qARocA6H"
                                allow="clipboard-write; picture-in-picture"
                                allowFullScreen
                                title={videoTitle}
                                loading="lazy"
                            />
                        </div>
                    </Content>

                    <div className={styles.blurEffect} aria-hidden>
                        <div className={styles.videoBlob} />
                    </div>
                </section>
            </div>
        </>
    );
};

export default CarPage;
